import { activity_recent, and, desc, eq, type PowerSyncDrizzleDB } from "@fieldcheck/powersync";

const DEFAULT_FEED_LIMIT = 200;

/**
 * Feed de actividad local (bucket PowerSync `activity_recent`, ~90 días).
 * El SQLite de la cuenta solo contiene sus buckets (scope personal + TODO lo
 * de sus organizaciones), así que no hace falta re-filtrar por usuario: el
 * feed ES "la actividad de la organización" (producto B2B).
 * Orden canónico: server_ts DESC (desempate por id UUIDv7).
 */
export function getActivityFeedQuery(db: PowerSyncDrizzleDB, options: { limit?: number } = {}) {
  return db
    .select()
    .from(activity_recent)
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}

/**
 * Historial local de una entidad concreta (para el sheet "Historial" del
 * detalle). El historial profundo (más allá de la retención) se pide a la API
 * (`GET /api/activity/entity/:type/:id`).
 */
export function getEntityActivityQuery(
  db: PowerSyncDrizzleDB,
  entityType: string,
  entityId: string,
  options: { limit?: number } = {},
) {
  return db
    .select()
    .from(activity_recent)
    .where(
      and(eq(activity_recent.entity_type, entityType), eq(activity_recent.entity_id, entityId)),
    )
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}
